import script from "./MarketSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketSection.vue?vue&type=script&setup=true&lang=js"

import "./MarketSection.vue?vue&type=style&index=0&id=a7a5b3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a5b3ae"]])

export default __exports__